import React from 'react';
import { Box, xcss, Flex } from '@atlaskit/primitives';

type GraphActionsWrapperProps = {
	children: React.ReactNode;
};

export const GraphActionsWrapper = ({ children }: GraphActionsWrapperProps) => (
	<Box xcss={actionWrapperStyles}>
		<Flex alignItems="center" justifyContent="space-between" columnGap="space.150">
			{children}
		</Flex>
	</Box>
);

const actionWrapperStyles = xcss({
	position: 'absolute',
	top: 'space.200',
	right: 'space.300',
	display: 'flex',
	alignItems: 'center',
	alignContent: 'center',
	flexFlow: 'row nowrap',
	justifyContent: 'space-between',
	background: 'red',
	borderRadius: 'radius.small',
	backgroundColor: 'elevation.surface.overlay',
	boxShadow: 'elevation.shadow.overlay',
	padding: 'space.100',
});
